import AxiosInstance from "src/api/AxiosInstance";
import { handleApiError } from "src/api/ErrorHandler";
import { ListParam } from "src/types/api/listParam";


export const getTodayView = async ( params: ListParam ) => {
    try {
        const response = await AxiosInstance.get("/message/day/view", {
            params: params
        });
        return response.data;
    } catch (error) {
        handleApiError("인기게시글 > 당일누적 > 조회수 불러오기 실패:");
        return null;
    }
};

export const getTodayViewRate = async ( params: ListParam ) => {
    try {
    const response = await AxiosInstance.get("/message/day/view_rate", {
        params: params
    });
    return response.data;
    } catch (error) {
        handleApiError("인기게시글 > 당일누적 > 열람율 불러오기 실패:");
        return null;
    }
};

export const getRealView = async ( params: ListParam ) => {
    try {
        const response = await AxiosInstance.get("/message/real/view", {
            params: params
        });
        return response.data;
    } catch (error) {
        handleApiError("인기게시글 > 실시간 > 조회수 불러오기 실패:");
        return null;
    }
};

export const getRealViewRate = async ( params: ListParam ) => {
    try {
        const response = await AxiosInstance.get("/message/real/view_rate", {
            params: params
        });
        return response.data;
    } catch (error) {
        handleApiError("인기게시글 > 실시간 > 열람율 불러오기 실패:");
        return null;
    }
  };
  

export const getPopular = async ( params: ListParam ) => {
    try {
        const response = await AxiosInstance.get("/message/popular", {
            params: params
        });
        return response.data;
    } catch (error) {
        handleApiError("인기종목 불러오기 실패:");
        return null;
    }
};

export const getStock = async ( params: ListParam ) => {
    try {
        const response = await AxiosInstance.get(`/message/stock`, {
            params: params
        });
    return response.data;
    } catch (error) {
        handleApiError("종목데이터 호출 실패");
        return null;
    }
};